// Dependecies
import { useState, useEffect } from 'react';
import { reject } from 'lodash';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

// Store
import user from '../../store/user';
import company from '../../store/company';
import dateService from '../../store/dateService';

// Hooks
import useLanguage from '../useLanguage';
import useAlert from '../useAlert';

function useJobRequest(reset, defaultValues, routeJobRequests, routePlansCompany, watch) {
  const { locale } = useLanguage();
  const history = useHistory();
  const { alertUpdate, messageError, messageAlert, setMessageError, setMessageAlert } = useAlert();
  const [userStore] = user();

  const [, companyActions] = company();
  const [storeDate] = dateService();
  const [itemTypeService, setItemTypeService] = useState([]);
  const [file, setFile] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);
  const [isCompleted1, setIsCompleted1] = useState(false);
  const [isCompleted2, setIsCompleted2] = useState(false);
  const [isCompleted3, setIsCompleted3] = useState(false);
  const [isCompleted4, setIsCompleted4] = useState(false);
  const [isCompleted5, setIsCompleted5] = useState(false);
  const [isCompleted6, setIsCompleted6] = useState(false);
  const [successfully, setSuccessfully] = useState(false);
  const [successSubmit, setSuccessSubmit] = useState(false);

  const [packagesCompany, SetPackagesCompany] = useState(userStore.packages);
  const [fileName, setFileName] = useState('');
  const [validateFile, setValidateFile] = useState(true);
  const [openModalError, setOpenModalError] = useState(false);
  const [openModalErrorVehicle, setOpenModalErrorVehicle] = useState(false);
  const [openModalErrorPlan, setOpenModalErrorPlan] = useState(false);

  const [usersCompanies, useSetUsersCompany] = useState([]);
  const [arrayDateDisabled, useSetArrayDateDisabled] = useState([]);
  const [, useSetImgOption] = useState(false);
  const [errorFile, useSetErrorFile] = useState(false);

  const [licensePlates, setLicensePlates] = useState(
    storeDate.placeRequest !== '' ? storeDate.placeRequest : 0
  );
  const [dateCalendar, useSetDateCalendar] = useState(
    storeDate.dateRequest !== '' ? storeDate.dateRequest : moment()
  );
  const [selectedTime, useSetSelectedTime] = useState(
    storeDate.hourRequest !== '' ? moment(storeDate.hourRequest, 'HH:mm:ss') : moment().add(1, 'h')
  );
  const [descriptionService] = useState(
    storeDate.descriptionRequest !== '' ? storeDate.descriptionRequest : 0
  );
  const [userVehicle, useSetUserVehicle] = useState(
    storeDate.userVehicleRequest !== '' ? storeDate.userVehicleRequest : ''
  );
  const [cityService, useSetCityService] = useState(
    storeDate.cityRequest !== '' ? storeDate.cityRequest : ''
  );

  const [cityGarage, useSetCityGarage] = useState(false);
  const [typeGarage, useSetTypeGarage] = useState(false);
  const [valType, useSetValType] = useState(false);
  const [garageEnableds, useSetGarageEnableds] = useState([]);
  const [garagaCar, useSetGaragaCar] = useState(false);

  const getSistems = (search) => {
    reset({
      sistems: [],
    });
    companyActions.getTypeService(userStore.token, locale, search).then(
      (type) => {
        setItemTypeService(type);
      },
      (e) => {
        if (e.status === 401) {
          reject(e);
        }
      }
    );
  };

  useEffect(() => {
    SetPackagesCompany(userStore.packages);
  }, [userStore.packages]);

  useEffect(() => {
    if (storeDate.hourRequest !== '') {
      setIsCompleted(true);
      setIsCompleted2(true);
      setIsCompleted3(true);
      setIsCompleted5(true);
    }
  }, [userStore.token]);
  useEffect(() => {
    if (userStore.token) {
      setMessageAlert(true);

      getSistems(false);

      companyActions.getDates(userStore.token, locale).then(
        (res) => {
          useSetArrayDateDisabled(res.arrayDateDisabled);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [userStore.token]);

  const onSubmit = async (data) => {
    try {
      if (validateFile) {
        setSuccessSubmit(true);
        const optionsIImage = {
          method: 'POST',
          body: file,
          headers: {
            Authorization: `bearer ${userStore.token}`,
          },
        };
        // Insert image
        const responseImage = await fetch(
          '/api/bread/jwt/services/static/insert_image',
          optionsIImage
        );
        const resImg = await responseImage.json();
        if (responseImage.status !== 200) {
          setMessageError(true);
        } else if (responseImage.success) {
          useSetImgOption(true);
        }
        const jsons = {
          imgOption: true,
          nameImg: resImg.original.name ? resImg.original.name : null,
          date: moment(dateCalendar).format('YYYY-MM-DD h:mm:ss'),
          hours: moment(selectedTime).format('HH:mm:00'),
          data,
        };

        const options = {
          method: 'POST',
          body: JSON.stringify(jsons),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `bearer ${userStore.token}`,
          },
        };

        // Insert new job request
        const response = await fetch(
          `/api/bread/jwt/services/static/insert_job_request?lang=${locale}`,
          options
        );
        const res = await response.json();

        if (res.status === 200) {
          setSuccessfully(true);
          reset(defaultValues);
          setFileName('');
          setSuccessSubmit(false);
        } else {
          setMessageError(true);
          setSuccessSubmit(false);
        }
      } else {
        setMessageError(true);
        setSuccessSubmit(false);
      }
    } catch (e) {
      reject();
      setSuccessSubmit(false);
    }
  };

  const searchLicensePlate = async () => {
    try {
      getSistems(false);

      const licensePlatesVal = licensePlates.replace(/ /g, '');

      if (licensePlatesVal.length > 0) {
        const jsons = {
          licensePlate: licensePlates,
        };

        const options = {
          method: 'POST',
          body: JSON.stringify(jsons),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `bearer ${userStore.token}`,
          },
        };
        const response = await fetch('/api/bread/jwt/vehicles/static/vehicle', options);
        const res = await response.json();
        if (!res.vehicle) {
          reset(defaultValues);
          setLicensePlates('');
          setFileName('');
          setOpenModalErrorVehicle(true);
        } else {
          useSetUsersCompany(res.usersComapany);
          setOpenModalErrorPlan(res.planAvailable);
          getSistems(licensePlates);

          if (res.planAvailable === true) {
            reset(defaultValues);
            setLicensePlates('');
          }
        }
      }
    } catch (e) {
      reject();
    }
  };

  useEffect(() => {
    if (licensePlates !== 0) {
      searchLicensePlate();
    }
  }, [userStore.licensePlates]);

  function OnFile(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('file', e.target.files[0]);
    formdata.append('name', e.target.files[0].name);
    setFile(formdata);
    const { size, type, name } = e.target.files[0];

    const validate =
      type === 'image/png' ||
      type === 'image/jpg' ||
      type === 'image/jpeg' ||
      type === 'application/pdf';
    const validateSize = size <= 6291456; // Validate file size is less than or equal to 6 MB

    setValidateFile(validate);

    if (validate) {
      if (validateSize) {
        setFileName(name);
        useSetErrorFile(false);
      } else {
        useSetErrorFile(true);
      }
    } else {
      useSetErrorFile(true);
      setValidateFile(false);
    }
  }

  // Disable the days before the current day
  function disabledDate(current) {
    const array = arrayDateDisabled;
    let bol = false;

    array.forEach((element) => {
      bol = bol || moment(element).format('YYYY-MM-DD') === current.format('YYYY-MM-DD');
    });

    return (current && current < moment().startOf('day')) || bol;
  }
  // Redirect register new vehicle
  function redirectVehicleRegistration() {
    const url = `/${locale}/${routeJobRequests}`;
    history.push(url);
  }

  const closeModal = () => {
    setOpenModalError(false);
    setOpenModalErrorVehicle(false);
    setOpenModalErrorPlan(false);
  };

  const send = () => {
    setOpenModalError(false);
  };

  const request = () => {
    redirectVehicleRegistration();
  };

  const requestPlan = () => {
    const url = `/${locale}/${routePlansCompany}`;
    history.push(url);
  };

  useEffect(() => {
    if (userStore.token) {
      const data = {
        date: moment(dateCalendar).format('YYYY-MM-DD'),
      };
      companyActions.getDate(userStore.token, locale, data).then(
        (res) => {
          if (res) {
            setOpenModalError(true);
            useSetDateCalendar('');
          }
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [dateCalendar]);

  function onPanelChange(date) {
    useSetDateCalendar(date);
  }

  const ontypeService = () => {
    const values = watch();
    let setType = false;

    const types = [];

    values.sistems.forEach((sistem) => {
      if (sistem.id) {
        types.push(sistem.id);
        setType = true;
      }
    });

    useSetCityGarage(values.city);
    useSetTypeGarage(values.sistems);
    useSetValType(setType);
  };

  const onSelect = (time) => {
    if (moment().format('YYYY-MM-DD') === moment(dateCalendar).format('YYYY-MM-DD')) {
      if (time.isBefore(moment())) {
        useSetSelectedTime(moment());
        return;
      }
    }
    useSetSelectedTime(time);
    ontypeService();
  };

  useEffect(() => {
    if (licensePlates && cityGarage && valType) {
      if (userStore.token) {
        const data = {
          date: moment(dateCalendar).format('YYYY-MM-DD'),
          hour: moment(selectedTime).format('HH:mm:00'),
          city: cityGarage,
          types: typeGarage,
        };
        companyActions.getGarage(userStore.token, locale, data).then(
          (res) => {
            if (res) {
              useSetGarageEnableds(res);
            }
          },
          (e) => {
            if (e.status === 401) {
              reject(e);
            }
          }
        );
      }
    }
  }, [selectedTime, licensePlates, cityGarage, typeGarage, dateCalendar]);

  return {
    alertUpdate,
    messageError,
    messageAlert,
    itemTypeService,
    onSubmit,
    OnFile,
    file,
    disabledDate,
    isCompleted,
    setIsCompleted,
    isCompleted1,
    setIsCompleted1,
    isCompleted2,
    setIsCompleted2,
    isCompleted3,
    setIsCompleted3,
    isCompleted4,
    setIsCompleted4,
    isCompleted5,
    setIsCompleted5,
    isCompleted6,
    setIsCompleted6,
    packagesCompany,
    fileName,
    validateFile,
    openModalError,
    closeModal,
    send,
    successfully,
    setSuccessfully,
    searchLicensePlate,
    setLicensePlates,
    licensePlates,
    openModalErrorVehicle,
    request,
    onPanelChange,
    usersCompanies,
    dateCalendar,
    errorFile,
    onSelect,
    selectedTime,
    ontypeService,
    garageEnableds,
    valType,
    useSetGaragaCar,
    garagaCar,
    descriptionService,
    userVehicle,
    useSetUserVehicle,
    cityService,
    useSetCityService,
    successSubmit,
    openModalErrorPlan,
    requestPlan,
  };
}

export default useJobRequest;
